import {useTranslation} from "react-i18next";
import {useDataProductForm} from "../useDataProductForm";
import React, {useEffect} from "react";
import {Form} from "react-bootstrap";
import {Tabs, Yup} from "../../components";
import DevicesForm from "../DevicesForm";
import ZonesAssociationForm from "../../zones/ZonesAssociationForm";
import StreamGeneralForm from "./StreamGeneralForm";
import AdminTab from "./AdminTab";
import {useGetCurrentUserQuery} from "../../../api/userApiSlice";
import PublisherFilter from "./PublisherFilter";

export default function StreamForm({stream, disabled, handleSubmit, tabProps, bucket, setSubmitButtonProps, errors, unbindBucket = false, extraTabs = []}) {
  const {t} = useTranslation();
  const {data: {isAdmin: userIsAdmin} = {}, isSuccess} = useGetCurrentUserQuery()
  const getValidationSchema = ()=>{
    let validationDef = {
      end_date: Yup.string().nullable()
    }
    if (userIsAdmin) {
      validationDef = {
        ...validationDef,
        api_environment: Yup.string(),
        column_mapping: Yup.string().nullable(),
      }
    }
    return Yup.object().shape(validationDef)
  }

  const dataProductFormProps = {
    onSubmit: handleSubmit,
    setSubmitButtonProps: setSubmitButtonProps,
    validationSchema: getValidationSchema(),
    unbindBucket: unbindBucket,
    disabled,
    errors
  }

  const {
    formData,
    setFormData,
    getInputProps,
    formProps,
    useParentFormRef,
    setDisabled
  } = useDataProductForm(dataProductFormProps);

  const tabsChildren = [
    <StreamGeneralForm
      formData={formData}
      getInputProps={getInputProps}
      disabled={disabled}
      bucket={bucket}
      as="stream"
      icon="stream"
    />,
    <DevicesForm
      formData={formData}
      getInputProps={getInputProps}
      disabled={disabled}
      as="devices"
      icon="mobile"
    />,
    <ZonesAssociationForm
      formData={formData}
      getInputProps={getInputProps}
      disabled={disabled}
      useParentFormRef={useParentFormRef}
      as="geography"
      icon="target"
    />,
    <PublisherFilter
      as="publisherFilter"
      icon="publisher"
      disabled={disabled}
      publisher_filters={formData.publisher_filters}
      useParentFormRef={useParentFormRef}
    />,
    <AdminTab
      as="admin"
      icon="admin"
      formData={formData}
      disabled={disabled}
      hide={!userIsAdmin}
      useParentFormRef={useParentFormRef}
      getInputProps={getInputProps}
    />
  ].concat(extraTabs)

  useEffect(() => {
    setDisabled(disabled)
  }, [disabled])

  useEffect(() => {
    setFormData(stream)
  }, [stream])

  return (
    <>
      <Form {...formProps}/>
      <Tabs {...tabProps} children={tabsChildren}/>
    </>
  )
}
